import React from 'react';

const defaultData = [
  { name: 'Strength', percentage: 75, color: '#FD3461' },
  { name: 'Cardio', percentage: 63, color: '#00B7FE' },
  { name: 'Mobility', percentage: 50, color: '#833A93' },
  { name: 'Flexibility', percentage: 25, color: '#FF6A00' },
];

const TrainingFocusChart = ({
  data = defaultData,
  size = 280,
  strokeWidth = 16,
}) => {
  const center = size / 2;
  const baseRadius = (size - strokeWidth) / 2 - 20;
  
  // Calculate the radius for each ring (from outer to inner)
  const rings = data.map((_, index) => ({
    radius: baseRadius - (index * (strokeWidth + 4)),
  }));

  const createPath = (percentage, radius) => {
    const angle = (percentage / 100) * 360;
    const radians = (angle - 90) * (Math.PI / 180);
    
    const x1 = center + radius * Math.cos(-Math.PI / 2);
    const y1 = center + radius * Math.sin(-Math.PI / 2);
    const x2 = center + radius * Math.cos(radians);
    const y2 = center + radius * Math.sin(radians);
    
    const largeArc = angle > 180 ? 1 : 0;
    
    return `M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`;
  };

  const createCirclePath = (percentage, radius) => {
    const circumference = 2 * Math.PI * radius;
    const strokeDasharray = circumference;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;
    
    return {
      circumference,
      strokeDasharray,
      strokeDashoffset,
    };
  };

  return (
    <div className="flex flex-col items-center space-y-6">
      {/* Chart Title */}
      <h3 className="text-lg font-semibold text-foreground">Training Focus Breakdown</h3>
      
      {/* Chart Container */}
      <div className="relative">
        <svg width={size} height={size} className="transform -rotate-90">
          {/* Background circles */}
          {rings.map((ring, index) => (
            <circle
              key={`bg-${index}`}
              cx={center}
              cy={center}
              r={ring.radius}
              fill="none"
              stroke="hsl(var(--muted))"
              strokeWidth={strokeWidth}
              opacity="0.1"
            />
          ))}
          
          {/* Progress circles */}
          {data.map((item, index) => {
            const ring = rings[index];
            const { strokeDasharray, strokeDashoffset } = createCirclePath(item.percentage, ring.radius);
            return (
              <circle
                key={`progress-${index}`}
                cx={center}
                cy={center}
                r={ring.radius}
                fill="none"
                stroke={item.color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeDasharray={strokeDasharray}
                strokeDashoffset={strokeDashoffset}
                className="transition-all duration-1000 ease-out"
                style={{
                  filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                }}
              />
            );
          })}
        </svg>
        
        {/* Percentage labels */}
        <div className="absolute inset-0 right-[50px] top-[10px]">
          <div className="flex flex-col text-center space-y-1">
            {data.map((item, index) => (
              <div
                key={`label-${index}`}
                className="text-sm"
                // style={{ color: item.color }}
              >
                {item.percentage}%
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Legend */}
      <div className="flex flex-wrap justify-center gap-4">
        {data.map((item, index) => (
          <div key={`legend-${index}`} className="flex items-center space-x-2">
            <div
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: item.color }}
            />
            <span className="text-sm font-medium text-foreground">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrainingFocusChart;